import Phaser from 'phaser';
import SauceDisplay from './SauceDisplay';
import SaucePainter from './SaucePainter';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../../UIAssetKeys';
import WorkArea from '../WorkArea';
import SoundAssetKeys from '../../SoundAssetKeys';

export default class SauceView extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {WorkArea} workAreaRef
   */
  constructor(scene, workAreaRef, workAreaPositions) {
    super(scene);

    this.workAreaRef = workAreaRef;
    this.viewPositions = workAreaPositions;

    this.toppingOverlay = null;

    this.isSquirting = false;
    this.canLand = false;
    this.bottleDestX = 0;

    this.sauce = new SauceDisplay(this.scene);
    this.sauce.sprite.x = this.viewPositions.centerX - this.sauce.sprite.width / 2 - 2;
    this.sauce.sprite.y = this.viewPositions.bottom - this.sauce.sprite.height - 4;

    this.spriteRect = { x: this.sauce.sprite.x, y: this.sauce.sprite.y, width: this.sauce.sprite.width, height: this.sauce.sprite.height };

    this.painter = new SaucePainter(this.scene, this.viewPositions);
    this.add(this.painter);

    this.bottleGroup = this.scene.add.container();
    this.fillYOffset = -94;
    this.bottleFill = ABCyaPhaser.Images.addImage(0,this.fillYOffset,UIAssetKeys._Sauce_Bottle_Fill, this.bottleGroup);
    this.bottle = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Sauce_Bottle, this.bottleGroup).setInteractive({ draggable: true });

    this.bottleGroup.x = this.viewPositions.centerX;
    this.bottleGroup.destY = this.bottle.height / 2;
    this.bottleGroup.y = this.bottleGroup.destY - this.bottle.height;
    this.bottleGroup.startY = this.bottleGroup.y;

    this.add(this.bottleGroup);

    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.grabBottle, this);
    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.dragBottle, this);
    this.bottle.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.dropBottle, this);

    this.switchFill(UIAssetKeys._Sauce_Bottle_Fill);

    this.lastDt = 0;
  }

  grabBottle (pointer) {
    if (this.workAreaRef.topScoopContainer) this.workAreaRef.topScoopContainer.sauceLayer.add(this.sauce);
    this.bottleGroup.dragOffsetX = this.bottleGroup.x - pointer.x;
    this.bottleGroup.dragOffsetY = this.bottleGroup.y - pointer.y;
    this.isSquirting = true;
    this.painter.startSquirt(this.bottleGroup.x, this.bottleGroup.y + this.bottle.height / 2);
    this.bottle.setFrame(UIAssetKeys._Sauce_Bottle_Squeeze);
    this.switchFill(UIAssetKeys._Sauce_Bottle_Squeeze_Fill,-3,3);
    this.dripSound = ABCyaPhaser.Audio.createSound(this.scene);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._TAP_Kitchen_Water_Tap_Drain_mono, this.dripSound);
  }

  switchFill (fn = UIAssetKeys._Sauce_Bottle_Fill, xoff = 0, yoff) {
    if (yoff === undefined) {
      // eslint-disable-next-line no-param-reassign
      yoff = this.fillYOffset;
    }
    else {
      // eslint-disable-next-line no-param-reassign
      yoff = this.fillYOffset + yoff;
    }
    this.bottleFill.setFrame(fn);
    this.bottleFill.x = xoff;
    this.bottleFill.y = yoff;
    this.bottleFill.setTintFill(Phaser.Display.Color.HexStringToColor(this.painter.selectedColor).color);
  }

  dragBottle (pointer) {
    this.bottleGroup.x = pointer.x + this.bottleGroup.dragOffsetX;
    const bxo = this.bottle.width / 2;
    if (this.bottleGroup.x - bxo <= this.viewPositions.left) this.bottleGroup.x = this.viewPositions.left + bxo;
    if (this.bottleGroup.x + bxo >= this.viewPositions.right) this.bottleGroup.x = this.viewPositions.right - bxo;
  }

  dropBottle () {
    this.isSquirting = false;
    this.painter.endSquirt();
    this.bottle.setFrame(UIAssetKeys._Sauce_Bottle);
    this.switchFill(UIAssetKeys._Sauce_Bottle_Fill);
    if (this.dripSound) {
      this.dripSound.stop();
      this.dripSound.destroy();
      this.dripSound = null;
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._KEY_Remove_Cut_Key_mono, this.scene);
  }

  getCurrentSauceImage () {
    if (this.canLand === false) return null;
    let img = null;
    if (this.painter.hasPainted) {
      img = new Phaser.GameObjects.RenderTexture(this.scene, this.spriteRect.x,this.spriteRect.y,this.spriteRect.width, this.spriteRect.height).setOrigin(0);
      img.drawFrame('saucedisplay');
      img.sauceValue = this.sauce.currentSauceValue;
      this.painter.resetMask();

      this.sauce.sauceDisplayCanvas.clear();
    }
    return img;
  }

  doOutro (time = 1000) {
    this.isActive = false;
    this.scene.tweens.killTweensOf(this.bottleGroup);
    ABCyaPhaser.Tweens.addTween(this.bottleGroup, time, { y: this.bottleGroup.startY, easeParams: [1,2] }, Phaser.Math.Easing.Elastic.Out);

    this.painter.resetMask();
  }

  doIntro (container, sundaeTop, canLand, topOffset) {
    if (this.workAreaRef.topScoopContainer) this.workAreaRef.topScoopContainer.sauceLayer.add(this.sauce);
    this.canLand = canLand;
    this.prepSauce(sundaeTop);
    this.isActive = true;
    const time = 1000;
    this.scene.tweens.killTweensOf(this.bottleGroup);
    ABCyaPhaser.Tweens.addTween(this.bottleGroup, time, { y: this.bottleGroup.destY, easeParams: [1, 0.75] }, Phaser.Math.Easing.Elastic.Out);
    container.add(this.sauce);
    this.sauce.y = topOffset;
    this.bottleGroup.x = this.viewPositions.centerX;
  }

  prepSauce (sundaeTop) {
    this.sauce.sprite.y = sundaeTop - 2;
    this.spriteRect.y = sundaeTop - 2;
  }

  switchSauce (sauceNumber, sauceColor) {
    const img = this.getCurrentSauceImage();
    this.painter.selectedColor = sauceColor;
    this.sauce.switchSauce(sauceNumber);
    this.switchFill();

    this.painter.resetMask();
    this.painter.cancelDrop();

    return img;
  }

  update (dt) {
    this.lastDt = dt;
    const amf = this.painter.update(dt);
    if (this.canLand && amf) {
      this.sauce.updateDisplayCanvas(amf);
    }
    if (this.isSquirting === true) {
      this.painter.addPoint(this.bottleGroup.x, this.bottleGroup.y + this.bottle.height / 2);
    }
  }
}